import {Error} from '@progress/kendo-react-labels';
import {
    InputHandle,
    MaskedTextBoxProps,
    MaskedTextBox,
    MaskedTextBoxEvent
} from "@progress/kendo-react-inputs";
import React, { useEffect, useRef, useState} from "react";
import "./FlintTextBox.scss";
import {GUID} from "../../utils/AppConstants";


export default function FlintMaskedTextBox(props: FlintMaskedTextBoxProps) {
    const [visited, setVisited] = useState(false);
    const inputRef = useRef<InputHandle | null>(null); // Corrected type for Kendo Input ref
    const {validationData, onBlur, ...other} = props;
    const handleBlur = (event: MaskedTextBoxEvent) => {
        setVisited(true);
        validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {});
        if (props.onBlur) {
            props.onBlur(event); // Call the parent's onBlur handler if provided
        }
    };
    
    return (
        <div className="flint-numeric-text-box">
            <MaskedTextBox
                {...other}
                ref={inputRef} // Use the corrected ref
                onBlur={handleBlur}
            />
            {validationData?.validationMessage != null && <Error>{validationData?.validationMessage}</Error>}
        </div>
    );
}

export interface FlintMaskedTextBoxProps extends MaskedTextBoxProps {
    validationData? : { validationMessage? : string | undefined, validateFunction? : (objectToValidate? : any)=>Promise<void>, optionalObjectToValidate? : any}
}
